import styled from 'styled-components';

import { minWidth } from 'styles/media-queries';
import { PageCuratedList } from 'components/organisms/curated-list';

export const Container = styled.div``;

export const CuratedList = styled(PageCuratedList)`
  padding-bottom: 2rem;
  padding-top: 2rem;

  &:first-child {
    padding-top: 6.4rem;
  }

  &:last-child {
    padding-bottom: 8rem;
  }

  ${minWidth.lg`
    padding-bottom: 4rem;
    padding-top: 4rem;

    &:first-child {
      padding-top: 11.2rem;
    }

    &:last-child {
      padding-bottom: 12rem;
    }
  `}
`;
